module.exports = __webpack_public_path__ + "img/10-1@2x.d7aedab2.png";